import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/Nav";
import { ProgressDots } from "@/components/ProgressDots";
import { Hero } from "@/components/Hero";
import { Statement } from "@/components/Statement";
import { Band } from "@/components/Band";
import { Specs } from "@/components/Specs";
import { Cta } from "@/components/Cta";
import { Footer } from "@/components/Footer";
import { WaitlistModal } from "@/components/WaitlistModal";
import { BANDS } from "@/data/copy";

function App() {
  const [waitlistOpen, setWaitlistOpen] = useState(false);

  useEffect(() => {
    document.documentElement.style.scrollBehavior = "smooth";
  }, []);

  const openShop = () => setWaitlistOpen(true);

  return (
    <div className="mk-app">
      <Nav onShop={openShop} />
      <ProgressDots />
      <main>
        <Hero />
        <Statement />
        <Band id="denim" data={BANDS.denim} />
        <Band id="tongue" data={BANDS.tongue} flip />
        <Band id="people" data={BANDS.people} />
        <Specs />
        <Cta onShop={openShop} />
      </main>
      <Footer />
      <WaitlistModal open={waitlistOpen} onOpenChange={setWaitlistOpen} />
      <Toaster position="bottom-center" />
    </div>
  );
}

export default App;
